import React from "react";
import { Text, Device, List } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { getAppState } from "../../../state";
import { getSubscription, getPaymentMethod } from "../../../utils/subscriptionUtils";
import { TextChannelsStyled } from "../styles/Styled";

const ACTIVE = "active";

function getPaymentData(subscriptionName, paymentMethodName) {
  const { subscriptions } = getAppState();
  const subscription = getSubscription(subscriptions, subscriptionName);
  const subscriptionPaymentMethod = getPaymentMethod(subscription, paymentMethodName);
  const { currency, grossAmount } =
    (subscriptionPaymentMethod &&
      !!subscriptionPaymentMethod.paymentPlans.length &&
      subscriptionPaymentMethod.paymentPlans[0]) ||
    {};
  return {
    currency,
    grossAmount
  };
}

function isActive(channelSubscriptionStatus) {
  return channelSubscriptionStatus === ACTIVE;
}

export const Channels = ({ channels }) => {
  // TODO refactor this part when the design for more than one channel is ready
  const channelPaymentData = {
    [`${i18n.get("pages.settings.channels.paymentMethod")}`]:
      (channels &&
        !!channels.length &&
        channels[0].paymentMethod &&
        channels[0].paymentMethod.paymentMethodParams &&
        channels[0].paymentMethod.paymentMethodParams.instrumentDetail) ||
      ""
  };

  return (
    <>
      {channels && !channels.length ? (
        <>
          <Text text={i18n.get("pages.settings.channels.notSubscriptions")} type="secondary" />
          <Text text={i18n.get("pages.settings.channels.visitOurWebsiteToManageSubscription")} type="secondary" />
        </>
      ) : (
        <>
          <List data={channelPaymentData} type="dl" display="inline" separator=":" />
          <TextChannelsStyled
            text={i18n.get("pages.settings.channels.visitOurWebsiteToManageSubscription")}
            type="secondary"
          />
          {channels.map(({ subscriptionName, status, nextBillingDate, paymentMethod: { paymentMethodName } }) => {
            const { currency, grossAmount } = getPaymentData(subscriptionName, paymentMethodName);
            const date = (nextBillingDate && `(${nextBillingDate})`) || "";
            const channelSubscriptionStatus = status.toLowerCase();
            return (
              <Device
                key={`key_${subscriptionName}`}
                deviceName={{
                  [`${i18n.get("pages.settings.accountStatus.status")}`]: `${i18n.get(
                    `pages.settings.accountStatus.statusValue.${channelSubscriptionStatus}`
                  )}`
                }}
                deviceKey={
                  isActive(channelSubscriptionStatus) && {
                    [`${i18n.get("pages.settings.channels.nextBill")} ${date}`]: `${currency} ${grossAmount}`
                  }
                }
                text={
                  !isActive(channelSubscriptionStatus) && {
                    "": [`${i18n.get("pages.settings.channels.disconnectedStatus")}`]
                  }
                }
                icon={subscriptionName}
              />
            );
          })}
        </>
      )}
    </>
  );
};
